"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SABRE_UPDATE_PRODUCT = void 0;
var client_1 = require("@apollo/client");
var fragments_1 = require("../fragments");
exports.SABRE_UPDATE_PRODUCT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation UpdateProduct($input: UpdateProductInput!) {\n    updateProduct(input: $input) {\n      product {\n        ...Product\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdateProduct($input: UpdateProductInput!) {\n    updateProduct(input: $input) {\n      product {\n        ...Product\n      }\n    }\n  }\n  ", "\n"])), fragments_1.SABRE_PRODUCT_FRAGMENT);
var templateObject_1;
